// import isSiteBuilder from './isSiteBuilder';

export default function getDomain(){
  // if(isSiteBuilder()) return "dev.orenda.finance";
  const domain = window.location.hostname;
  return domain.replace(/\./g, "_");

  // return "dev.orenda.finance";
}